export default __webpack_public_path__ + "static/media/civics-card.ee9a71b6.webp";